// UI strings for the 2021→2026 map, transitions, fun facts and TVK schemes pages.
export const INSIGHTS_T = {
  en: {
    nav_map: "Seat map 2021 → 2026",
    nav_facts: "Fun facts & TVK schemes",
    explore_title: "Explore the 2026 results",
    home_map_sub: "Every constituency's 2021 and 2026 winner — is the new MLA richer or more educated?",
    home_facts_sub: "Surprising numbers from the new Assembly and what TVK's promises may cost.",
    map_title: "Who won where: 2021 vs 2026",
    map_sub: "Tap any constituency to compare its 2021 and 2026 MLAs.",
    mode_party: "2026 winning party",
    mode_change: "What changed",
    outcome_flipped: "Seat changed party",
    outcome_same_mla: "Same MLA re-elected",
    outcome_same_mla_switched: "Same MLA, switched party",
    outcome_same_party_new: "Same party, new MLA",
    outcome_not_compared: "No 2021 comparison",
    mla_2021: "2021 MLA",
    mla_2026: "2026 MLA",
    not_listed: "Not listed on MyNeta",
    transition_title: "2021 → 2026: what changed here",
    edu_more: "More educated than the 2021 MLA",
    edu_less: "Less educated than the 2021 MLA",
    edu_same: "Same education level as the 2021 MLA",
    edu_na: "Education can't be compared",
    edu_more_self: "Declared a higher education level than in 2021",
    edu_less_self: "Declared a lower education level than in 2021",
    edu_same_self: "Same education level as declared in 2021",
    wealth_wealthier: "Wealthier than the 2021 MLA",
    wealth_poorer: "Poorer than the 2021 MLA",
    wealth_same: "Same declared assets as the 2021 MLA",
    wealth_na: "Wealth can't be compared",
    wealth_wealthier_self: "Declared more assets than in 2021",
    wealth_poorer_self: "Declared fewer assets than in 2021",
    wealth_same_self: "Same declared assets as in 2021",
    edu_na_note: "One of the two affidavits gives 'Others' or no level.",
    fate_not_returning: "The 2021 MLA is not in the 2026 winners list.",
    fate_moved: "The 2021 MLA won from {seat} in 2026.",
    match_probable: "Same-person match rated 'Probable':",
    assets_label: "Declared assets",
    cases_label: "Criminal cases",
    view_candidates: "See all 2026 candidates here",
    search_seat: "Find a constituency on the map",
    map_hint: "Pinch or use + to zoom into Chennai and other small seats.",
    zoom_in: "Zoom in",
    zoom_out: "Zoom out",
    zoom_reset: "Reset",
    seats_word: "seats",
    summary_edu: "New MLA vs 2021 MLA: education",
    summary_wealth: "New MLA vs 2021 MLA: declared assets",
    sum_more: "More educated",
    sum_less: "Less educated",
    sum_same: "Same level",
    sum_na: "Can't compare",
    sum_wealthier: "Wealthier",
    sum_poorer: "Poorer",
    sum_compared_note: "Based on {n} seats where both years are listed. Re-elected MLAs are compared with their own 2021 affidavit.",
    map_source: "Data: MyNeta (ADR) winners lists for 2021 and 2026, matched seat by seat. Assets, cases and education are as declared in affidavits; a declared case is not a conviction. Boundaries: DataMeet India community (CC BY 4.0).",
    tap_seat_prompt: "Tap a constituency on the map to see what changed.",
    facts_title: "Fun facts",
    facts_sub: "Surprising numbers from the 2026 Tamil Nadu Assembly and the winning party's manifesto.",
    tab_facts: "Assembly fun facts",
    tab_schemes: "TVK schemes",
    all_label: "All",
    seats_by_party_title: "Seats won by party, 2021 vs 2026",
    seats_by_party_note: "Counted from the seat-by-seat file: MyNeta lists 224 seats for 2021 and 233 for 2026.",
    method_title: "How this was worked out",
    big_cost_title: "What the 7 biggest cash promises could cost each year",
    big_cost_sub: "Indicative estimates in ₹ crore per year, at full manifesto rates. Not net of what the state already spends.",
    low_label: "Low estimate",
    high_label: "High estimate",
    total_label: "Total of these 7 promises",
    cr_year: "₹ Cr / year",
    context_title: "Context from Budget 2026-27 news reports",
    pillar_mix_title: "366 promises by pillar and type",
    alloc_title: "Money the manifesto itself names, by pillar (₹ Cr)",
    scheme_browser_title: "Browse every promise",
    scheme_search: "Search promises, e.g. pension, farmers, Rs 2,500",
    filter_pillar: "All pillars",
    filter_audience: "All audiences",
    showing_n: "Showing {n} of {total}",
    only_money: "Only promises with an amount",
    provisions_label: "Key provisions",
    beneficiaries_label: "Who it is for",
    benefit_label: "Benefit (as stated)",
    cost_label: "Indicative annual cost",
    allocation_label: "Allocation stated in manifesto",
    per_lakh_label: "Cost per 1 lakh beneficiaries",
    estimate_method_label: "How the estimate was made",
    cost_nature_label: "Likely cost nature",
    govt_action_label: "Government action so far (as of 24 Oct 2026)",
    page_label: "Manifesto page",
    sources_label: "Sources",
    type_scheme: "Scheme",
    type_infrastructure: "Infrastructure",
    type_policy: "Policy",
    type_advocacy: "Advocacy",
    cr: "Cr",
    lakh: "L",
    per_year: "per year",
    no_results: "No promises match your search.",
    ai_note: "",
    district_filter: "All of Tamil Nadu",
    district_label: "District",
    district_seats: "{n} seats",
    district_party_title: "Seats won by party",
    col_party: "Party",
    district_changes: "What changed in this district",
    district_seat_list: "Constituencies in this district",
    district_2021_note: "2021 counts include only seats listed on MyNeta for 2021.",
    district_clear: "Show all districts",
    share_seat: "Share as image",
    share_promise_msg: "TVK manifesto promise: {title} — see who it is for:",
    share_preparing: "Preparing image…",
    share_downloaded: "Image saved. Attach it in WhatsApp — the link is ready to send.",
    share_failed: "Couldn't create the image. Please try again.",
    share_seat_msg: "{seat}: 2021 MLA vs 2026 MLA — who is richer, more educated, with more cases? See the full comparison:",
    share_card_source: "Source: MyNeta (ADR) affidavits. Assets as declared; a declared case is not a conviction.",
    nav_home: "Home",
    nav_leaders: "Know Your Leaders",
    nav_changes: "See What's Changed",
    nav_schemes: "TVK Schemes",
    nav_candidates: "2026 Candidates",
    leaders_title: "Know your 2026 MLAs",
    leaders_sub: "Tap a constituency on the map, or pick a district, to see the declared details of its 2026 MLA.",
    changes_title: "See what's changed: 2021 vs 2026",
    district_mlas: "2026 MLAs in this district",
    see_changes_link: "See what changed here",
    leaders_prompt: "Tap a constituency or pick a district to see its MLA.",
    winner_2026: "Won in 2026",
    defeated_title: "Defeated ({n})",
    defeated_note: "The files have no vote counts, so the defeated candidates are listed in file order, not by votes.",
    no_winner_match: "The 2026 winner could not be matched to this candidate list.",
    candidates_title: "Who contested in 2026?",
    candidates_sub: "Pick a constituency to see every 2026 candidate, with the winner highlighted.",
    schemes_title: "What does the TVK manifesto promise you?",
    schemes_lede: "Every promise from TVK's 2026 manifesto, in plain language. Tap the tile that fits you, or search for anything.",
    who_title: "Who are you?",
    my_promises: "My promises",
    my_promises_sub: "Tick your family's groups",
    my_pick_title: "Which of these describe your family? Tick all that apply.",
    my_none: "Tick one or more groups above to see every promise for your family on one list.",
    my_total: "{n} promises for your family",
    my_total_1: "1 promise for your family",
    my_clear: "Clear all",
    who_sub: "Tap the tile that fits you to see the promises for you.",
    browse_sections: "Or browse by manifesto section",
    top_promises: "Top promises",
    top_promises_sub: "The biggest money benefits",
    top_glance: "Top promises at a glance",
    tap_group: "Tap a group above to see every promise for them.",
    promises_n: "{n} promises",
    promises_1: "1 promise",
    all_candidates_title: "Candidates ({n})",
    hidden_n: " · {n} more are rules, new facilities or demands to the Centre (untick the box to see them)",
    results_for: "Results for “{q}”",
    only_benefits: "Only money & direct benefits",
    search_promises: "Search: pension, loan, bus, gold, school…",
    for_label: "For:",
    page_n: "Manifesto page {g}",
    page_short: "page {g}",
    from_website: "From TVK website",
    ptype_Scheme: "Direct benefit",
    ptype_Infrastructure: "New facility",
    ptype_Policy: "Rule / reform",
    ptype_Advocacy: "Demand to Centre",
    nothing_found: "Nothing found. Try another word, or untick “Only money & direct benefits”.",
    costs_heading: "What the promises could cost",
    schemes_disclaimer: "Unofficial reading aid. Not published by, or affiliated with, any political party. Source: TVK 2026 manifesto (tvkvijay.com/en/manifesto).",
  },
  ta: {
    nav_map: "தொகுதி வரைபடம் 2021 → 2026",
    nav_facts: "சுவாரஸ்யத் தகவல்கள் & தவெக திட்டங்கள்",
    explore_title: "2026 முடிவுகளை ஆராயுங்கள்",
    home_map_sub: "ஒவ்வொரு தொகுதியின் 2021, 2026 வெற்றியாளர் — புதிய எம்எல்ஏ அதிக சொத்து உள்ளவரா, அதிகம் படித்தவரா?",
    home_facts_sub: "புதிய சட்டமன்றத்தின் வியப்பூட்டும் எண்கள் மற்றும் தவெக வாக்குறுதிகளின் செலவு.",
    map_title: "யார் எங்கு வென்றனர்: 2021 vs 2026",
    map_sub: "எந்தத் தொகுதியையும் தட்டி அதன் 2021, 2026 எம்எல்ஏக்களை ஒப்பிடுங்கள்.",
    mode_party: "2026 வென்ற கட்சி",
    mode_change: "என்ன மாறியது",
    outcome_flipped: "தொகுதி கட்சி மாறியது",
    outcome_same_mla: "அதே எம்எல்ஏ மீண்டும் வெற்றி",
    outcome_same_mla_switched: "அதே எம்எல்ஏ, வேறு கட்சி",
    outcome_same_party_new: "அதே கட்சி, புதிய எம்எல்ஏ",
    outcome_not_compared: "2021 ஒப்பீடு இல்லை",
    mla_2021: "2021 எம்எல்ஏ",
    mla_2026: "2026 எம்எல்ஏ",
    not_listed: "MyNeta-வில் பட்டியலிடப்படவில்லை",
    transition_title: "2021 → 2026: இங்கு என்ன மாறியது",
    edu_more: "2021 எம்எல்ஏவை விட அதிகம் படித்தவர்",
    edu_less: "2021 எம்எல்ஏவை விட குறைவாகப் படித்தவர்",
    edu_same: "2021 எம்எல்ஏவின் அதே கல்வி நிலை",
    edu_na: "கல்வியை ஒப்பிட முடியாது",
    edu_more_self: "2021-ஐ விட உயர்ந்த கல்வி நிலையை அறிவித்துள்ளார்",
    edu_less_self: "2021-ஐ விட குறைந்த கல்வி நிலையை அறிவித்துள்ளார்",
    edu_same_self: "2021-ல் அறிவித்த அதே கல்வி நிலை",
    wealth_wealthier: "2021 எம்எல்ஏவை விட அதிக சொத்து",
    wealth_poorer: "2021 எம்எல்ஏவை விட குறைந்த சொத்து",
    wealth_same: "2021 எம்எல்ஏவின் அதே சொத்து",
    wealth_na: "சொத்தை ஒப்பிட முடியாது",
    wealth_wealthier_self: "2021-ஐ விட அதிக சொத்து அறிவித்துள்ளார்",
    wealth_poorer_self: "2021-ஐ விட குறைந்த சொத்து அறிவித்துள்ளார்",
    wealth_same_self: "2021-ல் அறிவித்த அதே சொத்து",
    edu_na_note: "இரண்டு பிரமாணப் பத்திரங்களில் ஒன்றில் 'மற்றவை' அல்லது கல்வி நிலை இல்லை.",
    fate_not_returning: "2021 எம்எல்ஏ 2026 வெற்றியாளர் பட்டியலில் இல்லை.",
    fate_moved: "2021 எம்எல்ஏ 2026-ல் {seat} தொகுதியில் வென்றார்.",
    match_probable: "ஒரே நபர் பொருத்தம் 'சாத்தியமானது' என மதிப்பிடப்பட்டது:",
    assets_label: "அறிவித்த சொத்து",
    cases_label: "குற்ற வழக்குகள்",
    view_candidates: "இங்குள்ள அனைத்து 2026 வேட்பாளர்களைப் பார்க்க",
    search_seat: "வரைபடத்தில் தொகுதியைத் தேடுங்கள்",
    map_hint: "சென்னை போன்ற சிறிய தொகுதிகளைப் பார்க்க விரல்களால் பெரிதாக்கவும் அல்லது + அழுத்தவும்.",
    zoom_in: "பெரிதாக்கு",
    zoom_out: "சிறிதாக்கு",
    zoom_reset: "மீட்டமை",
    seats_word: "இடங்கள்",
    summary_edu: "புதிய எம்எல்ஏ vs 2021 எம்எல்ஏ: கல்வி",
    summary_wealth: "புதிய எம்எல்ஏ vs 2021 எம்எல்ஏ: அறிவித்த சொத்து",
    sum_more: "அதிகம் படித்தவர்",
    sum_less: "குறைவாகப் படித்தவர்",
    sum_same: "அதே நிலை",
    sum_na: "ஒப்பிட முடியாது",
    sum_wealthier: "அதிக சொத்து",
    sum_poorer: "குறைந்த சொத்து",
    sum_compared_note: "இரு ஆண்டுகளும் பட்டியலிடப்பட்ட {n} தொகுதிகளின் அடிப்படையில். மீண்டும் வென்ற எம்எல்ஏக்கள் அவர்களின் சொந்த 2021 பிரமாணப் பத்திரத்துடன் ஒப்பிடப்படுகின்றனர்.",
    map_source: "தரவு: MyNeta (ADR) 2021, 2026 வெற்றியாளர் பட்டியல்கள், தொகுதி வாரியாகப் பொருத்தப்பட்டவை. சொத்து, வழக்குகள், கல்வி ஆகியவை பிரமாணப் பத்திரங்களில் அறிவித்தபடி; அறிவிக்கப்பட்ட வழக்கு தண்டனை அல்ல. எல்லைகள்: DataMeet India community (CC BY 4.0).",
    tap_seat_prompt: "என்ன மாறியது என்பதைப் பார்க்க வரைபடத்தில் ஒரு தொகுதியைத் தட்டவும்.",
    facts_title: "சுவாரஸ்யத் தகவல்கள்",
    facts_sub: "2026 தமிழ்நாடு சட்டமன்றம் மற்றும் வென்ற கட்சியின் தேர்தல் அறிக்கையிலிருந்து வியப்பூட்டும் எண்கள்.",
    tab_facts: "சட்டமன்றத் தகவல்கள்",
    tab_schemes: "தவெக திட்டங்கள்",
    all_label: "அனைத்தும்",
    seats_by_party_title: "கட்சி வாரியாக வென்ற இடங்கள், 2021 vs 2026",
    seats_by_party_note: "தொகுதி வாரியான கோப்பிலிருந்து கணக்கிடப்பட்டது: MyNeta 2021-க்கு 224, 2026-க்கு 233 தொகுதிகளைப் பட்டியலிடுகிறது.",
    method_title: "இது எப்படிக் கணக்கிடப்பட்டது",
    big_cost_title: "7 பெரிய பண வாக்குறுதிகளுக்கு ஆண்டுக்கு ஆகக்கூடிய செலவு",
    big_cost_sub: "முழு அறிக்கை விகிதத்தில், ஆண்டுக்கு ₹ கோடியில் தோராயமான மதிப்பீடுகள். அரசு ஏற்கனவே செலவிடும் தொகை கழிக்கப்படவில்லை.",
    low_label: "குறைந்த மதிப்பீடு",
    high_label: "அதிக மதிப்பீடு",
    total_label: "இந்த 7 வாக்குறுதிகளின் மொத்தம்",
    cr_year: "₹ கோடி / ஆண்டு",
    context_title: "2026-27 பட்ஜெட் செய்திகளிலிருந்து பின்னணி",
    pillar_mix_title: "தூண் மற்றும் வகை வாரியாக 366 வாக்குறுதிகள்",
    alloc_title: "அறிக்கையே குறிப்பிடும் தொகை, தூண் வாரியாக (₹ கோடி)",
    scheme_browser_title: "ஒவ்வொரு வாக்குறுதியையும் பாருங்கள்",
    scheme_search: "வாக்குறுதிகளைத் தேடுங்கள், எ.கா. ஓய்வூதியம், விவசாயிகள்",
    filter_pillar: "அனைத்து தூண்கள்",
    filter_audience: "அனைத்து பயனாளிகள்",
    showing_n: "{total}-ல் {n} காட்டப்படுகிறது",
    only_money: "தொகை உள்ள வாக்குறுதிகள் மட்டும்",
    provisions_label: "முக்கிய அம்சங்கள்",
    beneficiaries_label: "யாருக்காக",
    benefit_label: "பலன் (அறிக்கையில் உள்ளபடி)",
    cost_label: "தோராயமான ஆண்டுச் செலவு",
    allocation_label: "அறிக்கையில் கூறப்பட்ட ஒதுக்கீடு",
    per_lakh_label: "1 லட்சம் பயனாளிகளுக்கான செலவு",
    estimate_method_label: "மதிப்பீடு எப்படிச் செய்யப்பட்டது",
    cost_nature_label: "செலவின் தன்மை",
    govt_action_label: "இதுவரை அரசு நடவடிக்கை (24 அக். 2026 நிலவரம்)",
    page_label: "அறிக்கைப் பக்கம்",
    sources_label: "ஆதாரங்கள்",
    type_scheme: "திட்டம்",
    type_infrastructure: "உள்கட்டமைப்பு",
    type_policy: "கொள்கை",
    type_advocacy: "கோரிக்கை",
    cr: "கோடி",
    lakh: "லட்சம்",
    per_year: "ஆண்டுக்கு",
    no_results: "உங்கள் தேடலுக்குப் பொருந்தும் வாக்குறுதிகள் இல்லை.",
    ai_note: "இந்த விளக்கங்கள் ஆங்கிலத்திலிருந்து AI மூலம் மொழிபெயர்க்கப்பட்டவை; சிறிய சொல் பிழைகள் இருக்கலாம். எண்கள் மூலத் தரவிலிருந்தே எடுக்கப்பட்டவை.",
    district_filter: "தமிழ்நாடு முழுவதும்",
    district_label: "மாவட்டம்",
    district_seats: "{n} தொகுதிகள்",
    district_party_title: "கட்சி வாரியாக வென்ற இடங்கள்",
    col_party: "கட்சி",
    district_changes: "இந்த மாவட்டத்தில் என்ன மாறியது",
    district_seat_list: "இந்த மாவட்டத்தின் தொகுதிகள்",
    district_2021_note: "2021 எண்ணிக்கையில் MyNeta-வில் பட்டியலிடப்பட்ட தொகுதிகள் மட்டுமே.",
    district_clear: "அனைத்து மாவட்டங்களையும் காட்டு",
    share_seat: "படமாகப் பகிருங்கள்",
    share_promise_msg: "தவெக தேர்தல் அறிக்கை வாக்குறுதி: {title} — யாருக்கு என்று பாருங்கள்:",
    share_preparing: "படம் தயாராகிறது…",
    share_downloaded: "படம் சேமிக்கப்பட்டது. WhatsApp-ல் இணைத்து அனுப்புங்கள் — இணைப்பு தயாராக உள்ளது.",
    share_failed: "படத்தை உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    share_seat_msg: "{seat}: 2021 எம்எல்ஏ vs 2026 எம்எல்ஏ — யாருக்கு அதிக சொத்து, அதிக படிப்பு, அதிக வழக்குகள்? முழு ஒப்பீடு:",
    share_card_source: "ஆதாரம்: MyNeta (ADR) பிரமாணப் பத்திரங்கள். அறிவித்தபடி சொத்து; அறிவிக்கப்பட்ட வழக்கு தண்டனை அல்ல.",
    nav_home: "முகப்பு",
    nav_leaders: "உங்கள் தலைவர்களை அறியுங்கள்",
    nav_changes: "என்ன மாறியது",
    nav_schemes: "தவெக திட்டங்கள்",
    nav_candidates: "2026 வேட்பாளர்கள்",
    leaders_title: "உங்கள் 2026 எம்எல்ஏக்களை அறியுங்கள்",
    leaders_sub: "வரைபடத்தில் ஒரு தொகுதியைத் தட்டவும் அல்லது மாவட்டத்தைத் தேர்ந்தெடுக்கவும் — அதன் 2026 எம்எல்ஏவின் அறிவித்த விவரங்களைப் பாருங்கள்.",
    changes_title: "என்ன மாறியது: 2021 vs 2026",
    district_mlas: "இந்த மாவட்டத்தின் 2026 எம்எல்ஏக்கள்",
    see_changes_link: "இங்கு என்ன மாறியது",
    leaders_prompt: "எம்எல்ஏவைப் பார்க்க ஒரு தொகுதியைத் தட்டவும் அல்லது மாவட்டத்தைத் தேர்ந்தெடுக்கவும்.",
    winner_2026: "2026-ல் வெற்றி",
    defeated_title: "தோல்வியடைந்தவர்கள் ({n})",
    defeated_note: "கோப்புகளில் வாக்கு எண்ணிக்கை இல்லை; எனவே தோல்வியடைந்தவர்கள் வாக்கு வரிசையில் அல்ல, கோப்பில் உள்ள வரிசையில் காட்டப்படுகின்றனர்.",
    no_winner_match: "2026 வெற்றியாளரை இந்த வேட்பாளர் பட்டியலுடன் பொருத்த முடியவில்லை.",
    candidates_title: "2026-ல் யார் போட்டியிட்டனர்?",
    candidates_sub: "ஒரு தொகுதியைத் தேர்ந்தெடுத்து அனைத்து 2026 வேட்பாளர்களையும் பாருங்கள்; வெற்றியாளர் முன்னிலைப்படுத்தப்படுவார்.",
    schemes_title: "தவெக தேர்தல் அறிக்கை உங்களுக்கு என்ன வாக்குறுதி அளிக்கிறது?",
    schemes_lede: "தவெக 2026 தேர்தல் அறிக்கையின் ஒவ்வொரு வாக்குறுதியும், எளிய மொழியில். உங்களுக்குப் பொருந்தும் கட்டத்தைத் தட்டவும் அல்லது எதையும் தேடுங்கள்.",
    who_title: "நீங்கள் யார்?",
    my_promises: "என் வாக்குறுதிகள்",
    my_promises_sub: "உங்கள் குடும்பப் பிரிவுகளைத் தேர்ந்தெடுங்கள்",
    my_pick_title: "இவற்றில் எவை உங்கள் குடும்பத்திற்குப் பொருந்தும்? பொருந்தும் அனைத்தையும் தேர்ந்தெடுங்கள்.",
    my_none: "உங்கள் குடும்பத்திற்கான அனைத்து வாக்குறுதிகளையும் ஒரே பட்டியலில் பார்க்க மேலே ஒன்று அல்லது அதற்கு மேற்பட்ட பிரிவுகளைத் தேர்ந்தெடுங்கள்.",
    my_total: "உங்கள் குடும்பத்திற்கு {n} வாக்குறுதிகள்",
    my_total_1: "உங்கள் குடும்பத்திற்கு 1 வாக்குறுதி",
    my_clear: "அனைத்தையும் நீக்கு",
    who_sub: "உங்களுக்குப் பொருந்தும் கட்டத்தைத் தட்டி உங்களுக்கான வாக்குறுதிகளைப் பாருங்கள்.",
    browse_sections: "அல்லது அறிக்கைப் பிரிவு வாரியாகப் பார்க்க",
    top_promises: "முக்கிய வாக்குறுதிகள்",
    top_promises_sub: "மிகப்பெரிய பண நன்மைகள்",
    top_glance: "முக்கிய வாக்குறுதிகள் ஒரே பார்வையில்",
    tap_group: "ஒவ்வொரு வாக்குறுதியையும் பார்க்க மேலே ஒரு பிரிவைத் தட்டவும்.",
    promises_n: "{n} வாக்குறுதிகள்",
    promises_1: "1 வாக்குறுதி",
    all_candidates_title: "வேட்பாளர்கள் ({n})",
    hidden_n: " · மேலும் {n} விதிகள், புதிய வசதிகள் அல்லது மத்திய அரசிடம் கோரிக்கைகள் (பார்க்க பெட்டியைத் தேர்வுநீக்கவும்)",
    results_for: "“{q}” க்கான முடிவுகள்",
    only_benefits: "பணம் & நேரடி நன்மைகள் மட்டும்",
    search_promises: "தேடுங்கள்: ஓய்வூதியம், கடன், பேருந்து, தங்கம், பள்ளி…",
    for_label: "யாருக்கு:",
    page_n: "அறிக்கைப் பக்கம் {g}",
    page_short: "பக்கம் {g}",
    from_website: "தவெக இணையதளத்திலிருந்து",
    ptype_Scheme: "நேரடி நன்மை",
    ptype_Infrastructure: "புதிய வசதி",
    ptype_Policy: "விதி / சீர்திருத்தம்",
    ptype_Advocacy: "மத்திய அரசிடம் கோரிக்கை",
    nothing_found: "எதுவும் கிடைக்கவில்லை. வேறு சொல்லை முயற்சிக்கவும் அல்லது “பணம் & நேரடி நன்மைகள் மட்டும்” தேர்வுநீக்கவும்.",
    costs_heading: "வாக்குறுதிகளுக்கு ஆகக்கூடிய செலவு",
    schemes_disclaimer: "அதிகாரப்பூர்வமற்ற வாசிப்பு உதவி. எந்த அரசியல் கட்சியாலும் வெளியிடப்படவில்லை, தொடர்புடையதும் அல்ல. ஆதாரம்: தவெக 2026 தேர்தல் அறிக்கை (tvkvijay.com/en/manifesto).",
  },
};
